module.exports = __webpack_public_path__ + "img/reference.d09bc628.png";